module.exports = __webpack_public_path__ + "static/media/feature-no-contract.99003618.svg";